import {
  fetchData,
  fetchDataSuccess,
  fetchDataError,
} from "../../../redux/classes/provider-portal/GetSpecificWorkerIndSlice";

import axios from "axios";
import * as actionType from "../../../constant/actionType";
export const GetIndWorkerByAssignedClients = (apiData) => async (dispatch) => {
  /*** API Call Action ***/
  try {
    dispatch(fetchData());
    const response = await axios({
      method: "get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
      },
      url: `${actionType.environment_url}/api/worker/GetIndStatusOfWorkerByAssignedClients`,
      params: apiData,
    });
    dispatch(fetchDataSuccess(response.data));
  } catch (error) {
    dispatch(fetchDataError(error.message));
  }
};
